module.exports = __webpack_public_path__ + "img/pc-ydj.520b1add.jpg";